var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6085 1.90381H21.982L14.6119 10.3273L23.2822 21.7898H16.4935L11.1763 14.8378L5.09217 21.7898H1.71666L9.59966 12.7799L1.28223 1.90381H8.24334L13.0496 8.25814L18.6085 1.90381ZM17.4245 19.7706H19.2938L7.22762 3.81694H5.22169L17.4245 19.7706Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcons);
export default __webpack_public_path__ + "static/media/Social Icons.dbbf3b4ba75f27b66d6ab8b90093d46b.svg";
export { ForwardRef as ReactComponent };